import type { FaireProductEntity } from "../../entity_types/product";

export const p_q47fsyeyjd: FaireProductEntity = {
  token: "p_q47fsyeyjd",
  type: "product",
  name: "Lindo Car Portable Diffuser/Humidifier with Night Light",
  brandToken: "b_sgxnio4cg9",
  brandName: "Lindo",
  imageUrl:
    "https://cdn.faire.com/fastly/e6155301adafd853ee52a8b89ae69ac81d46cc317d6b4dbb36c4ce180370e29d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0a3bf84d749bdb8598f3f436a30d263042cf7bf54bc1d9f8639afbf2725cd66.jpeg",
    "https://cdn.faire.com/fastly/71736bbb2539d8fb996626a4123781544a6489f3c22b168f88a8efc7e2842ca6.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Lindo Car Portable Diffuser is a rechargeable 3-in-1 diffuser/ humidifier/ night light with USB port perfect for use in the car. The diffuser provides a soothing fine mist while the 7 color LED transitions seamlessly between all colors of the rainbow. It's ultra quiet, use with water or add essential oils for a calming scent. Breathe easy as the diffuser helps prevent the harsh effects of dry air and eases common cold-like symptoms or sinus issues, also helps moisturize your skin. \n*Press the power button and release immediately for mist. Press the power button for two seconds to turn on the light. \n*Comes with two cotton sticks filter and one USB cable. Make sure the spring in the inner tube does not fall out. Soak the filter in water 2-3 mins prior to usage. \n*If it's your fist time using the diffuser, it will take about 20-30 seconds to activate the mist once you turn it on. After the initial usage, next time when you press the power button, the mist will be released right away.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:58.634Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
